import React, { useState } from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Tooltip,
  useTheme,
} from '@mui/material';
import {
  // DashboardOutlined,
  // SettingsOutlined,
  // PersonOutlined,
  // PeopleOutlined,
  // ClassOutlined,
  // AssignmentOutlined,
  // AssessmentOutlined,
  // PeopleOutlined,
  // LocalShippingOutlined,
  // CategoryOutlined,
  // InventoryOutlined,
  // PaymentOutlined,
  HomeWorkOutlined,
  AccountBalanceOutlined,
  BookOnlineOutlined,
  HistoryOutlined,
  // ExpandLess,
  // // ExpandMore,
  // SchoolOutlined,
  // // Settings,
  // CalendarToday,
  // SubjectOutlined,
  // // Assignment,
  // // PersonAddOutlined,
  // BadgeOutlined,
  // ClassOutlined,
  // AssignmentRounded,
  // // SettingsRounded,
  // SettingsOutlined,
  ExpandLessRounded,
  ExpandMoreRounded,
  // AccessTime,
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useViewPort, useAuth } from '@/hooks';
import { Collapse } from '@mui/material';
import { USER_ROLES } from '@/constants/app';

const DRAWER_WIDTH = 240;
const DRAWER_WIDTH_COLLAPSED = 64;

interface NavigationItem {
  id: string;
  label: string;
  icon: React.ReactElement;
  path?: string;
  roles?: string[];
  children?: NavigationItem[];
}

const navigationItems: NavigationItem[] = [
  // {
  //   id: 'dashboard',
  //   label: 'Dashboard',
  //   icon: <DashboardOutlined />,
  //   path: '/dashboard',
  //   roles: [USER_ROLES.EMPLOYEE, USER_ROLES.ADMIN, USER_ROLES.MANAGER,],
  // },
{
    id: 'bookings',
    label: 'Bookings',
    icon: <BookOnlineOutlined />,
    path: '/bookings',
    roles: [USER_ROLES.Booking_SuperAdmin, USER_ROLES.Booking_Admin],
  },
 
  {
    id: 'facilities',
    label: 'Facilities',
    icon: <HomeWorkOutlined />,
    path: '/facilities',
    roles: [USER_ROLES.Booking_SuperAdmin],
  },
  {
    id: 'fraternity',
    label: 'Fraternity',
    icon: <AccountBalanceOutlined />,
    path: '/fraternity',
    roles: [USER_ROLES.Booking_SuperAdmin],
  },
  {
    id: 'booking-logs',
    label: 'Booking Logs',
    icon: <HistoryOutlined />,
    path: '/booking-logs',
    roles: [USER_ROLES.Booking_SuperAdmin],
  },
  // {
  //   id: 'customers',
  //   label: 'Customers',
  //   icon: <PeopleOutlined />,
  //   path: '/customers',
  //   roles: [USER_ROLES.ADMIN, USER_ROLES.MANAGER],
  // },
  // {
  //   id: 'suppliers',
  //   label: 'Suppliers',
  //   icon: <LocalShippingOutlined />,
  //   path: '/suppliers',
  //   roles: [USER_ROLES.ADMIN, USER_ROLES.MANAGER],
  // },
  // {
  //   id: 'materials',
  //   label: 'Materials',
  //   icon: <CategoryOutlined />,
  //   path: '/materials',
  //   roles: [USER_ROLES.ADMIN, USER_ROLES.MANAGER],
  // },
  // {
  //   id: 'purchase-orders',
  //   label: 'Purchase Orders',
  //   icon: <ReceiptOutlined />,
  //   path: '/purchase-orders',
  //   roles: [USER_ROLES.ADMIN, USER_ROLES.MANAGER],
  // },
  //  {
  //       id: 'attendance',
  //       label: 'Attendance',
  //       icon: <AssessmentOutlined />,
  //       path: '/attendance',
  //       roles: [USER_ROLES.EMPLOYEE, USER_ROLES.ADMIN, USER_ROLES.MANAGER],
  //     },
  // {
  //   id: 'management',
  //   label: 'Management',
  //   icon: <SchoolOutlined />,
  //   roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER, USER_ROLES.ACCOUNTANT, USER_ROLES.TEACHER, USER_ROLES.STAFF, USER_ROLES.HELPER, USER_ROLES.DRIVER, USER_ROLES.SUPERVISOR, USER_ROLES.HR, USER_ROLES.USER_G1, USER_ROLES.USER_G2],
  //   children: [
  //     {
  //       id: 'students',
  //       label: 'Students',
  //       icon: <PeopleOutlined />,
  //       path: '/students',
  //       roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER, USER_ROLES.ACCOUNTANT, USER_ROLES.TEACHER, USER_ROLES.STAFF, USER_ROLES.HELPER, USER_ROLES.DRIVER, USER_ROLES.SUPERVISOR, USER_ROLES.HR, USER_ROLES.USER_G1, USER_ROLES.USER_G2],
  //     },
  //     // {
  //     //   id: 'teachers',
  //     //   label: 'Teachers',
  //     //   icon: <PersonOutlined />,
  //     //   path: '/teachers',
  //     //   roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER],
  //     // },
  //     {
  //       id: 'staff',
  //       label: 'Staff',
  //       icon: <BadgeOutlined />,
  //       path: '/staff',
  //       roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER],
  //     },
     
  //     // {
  //     //   id: 'classes',
  //     //   label: 'Classes',
  //     //   icon: <ClassOutlined />,
  //     //   path: '/classes',
  //     //   roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER, USER_ROLES.ACCOUNTANT, USER_ROLES.TEACHER, USER_ROLES.STAFF, USER_ROLES.HELPER, USER_ROLES.DRIVER, USER_ROLES.SUPERVISOR, USER_ROLES.HR, USER_ROLES.USER_G1, USER_ROLES.USER_G2],
  //     // },
  //   ],
  // },
  // {
  //   id: 'academic',
  //   label: 'Academic',
  //   icon: <AssignmentOutlined />,
  //   roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER, USER_ROLES.ACCOUNTANT, USER_ROLES.TEACHER, USER_ROLES.STAFF, USER_ROLES.HELPER, USER_ROLES.DRIVER, USER_ROLES.SUPERVISOR, USER_ROLES.HR, USER_ROLES.USER_G1, USER_ROLES.USER_G2, USER_ROLES.STUDENT],
  //   children: [
  //     {
  //       id: 'assignments',
  //       label: 'Assignments',
  //       icon: <AssignmentOutlined />,
  //       path: '/assignments',
  //       roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER, USER_ROLES.ACCOUNTANT, USER_ROLES.TEACHER, USER_ROLES.STAFF, USER_ROLES.HELPER, USER_ROLES.DRIVER, USER_ROLES.SUPERVISOR, USER_ROLES.HR, USER_ROLES.USER_G1, USER_ROLES.USER_G2, USER_ROLES.STUDENT],
  //     },
  //     // {
  //     //   id: 'attendance',
  //     //   label: 'Attendance',
  //     //   icon: <AssessmentOutlined />,
  //     //   path: '/attendance',
  //     //   roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER, USER_ROLES.ACCOUNTANT, USER_ROLES.TEACHER, USER_ROLES.STAFF, USER_ROLES.HELPER, USER_ROLES.DRIVER, USER_ROLES.SUPERVISOR, USER_ROLES.HR, USER_ROLES.USER_G1, USER_ROLES.USER_G2],
  //     // },
  //   ],
  // },
  // {
  //   id: 'reports',
  //   label: 'Reports',
  //   icon: <AssessmentOutlined />,
  //   path: '/reports',
  //   roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER],
  // },
  // {
  //   id: 'onboarding',
  //   label: 'Onboarding',
  //   icon: <PersonAddOutlined />,
  //   path: '/onboarding',
  //   roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER],
  // },
  // {
  //   id: 'profile',
  //   label: 'Profile',
  //   icon: <PersonOutlined />,
  //   path: '/profile',
  //   roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER, USER_ROLES.ACCOUNTANT, USER_ROLES.TEACHER, USER_ROLES.STAFF, USER_ROLES.HELPER, USER_ROLES.DRIVER, USER_ROLES.SUPERVISOR, USER_ROLES.HR, USER_ROLES.USER_G1, USER_ROLES.USER_G2, USER_ROLES.STUDENT, USER_ROLES.PARENT],
  // },
  // {
  //   id: 'configuration',
  //   label: 'Configuration',
  //   icon: <SettingsOutlined />,
  //   roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER],
  //   children: [
  //     {
  //       id: 'academic-year',
  //       label: 'Academic Year',
  //       icon: <CalendarToday />,
  //       path: '/configuration/academic-year',
  //       roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER],
  //     },
  //     {
  //       id: 'subjects',
  //       label: 'Subjects',
  //       icon: <SubjectOutlined />,
  //       path: '/configuration/subjects',
  //       roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER],
  //     },
  //     {
  //       id: 'section-standard',
  //       label: 'Section & Standard',
  //       icon: <AssignmentRounded />,
  //       path: '/configuration/section-standard',
  //       roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER],
  //     },
  //      {
  //       id: 'assign-classes',
  //       label: 'Subject & Staffs',
  //       icon: <ClassOutlined />,
  //       path: '/assign-classes',
  //       roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER],
  //     },
  //     // {
  //     //   id: 'timeslot',
  //     //   label: 'Timeslots',
  //     //   icon: <AccessTime />,
  //     //   path: '/configuration/timeslot',
  //     //   roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER],
  //     // },
  //     // {
  //     //   id: 'subject-standard-mapping',
  //     //   label: 'Subject-Standard',
  //     //   icon: <Assignment />,
  //     //   path: '/configuration/subject-standard-mapping',
  //     //   roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER],
  //     // },
  //     // {
  //     //   id: 'subject-configuration',
  //     //   label: 'Subject Configuration',
  //     //   icon: <SubjectOutlined />,
  //     //   path: '/configuration/subject-configuration',
  //     //   roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER],
  //     // },
  //   ],
  // },
  // {
  //   id: 'settings',
  //   label: 'Settings',
  //   icon: <SettingsOutlined />,
  //   path: '/settings',
  //   roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER],
  // },
];

interface SidebarProps {
  mobileOpen: boolean;
  onMobileClose: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({
  mobileOpen,
  onMobileClose,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { isMobile } = useViewPort();
  const { user } = useAuth();
  const [isHovered, setIsHovered] = useState(false);
  const [expandedItems, setExpandedItems] = useState<string[]>([]);

  const isCollapsed = !isMobile && !isHovered;
  const drawerWidth = isCollapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH;

  const handleNavigate = (path: string) => {
    navigate(path);
    if (isMobile) {
      onMobileClose();
    }
  };

  const handleToggleExpanded = (itemId: string) => {
    setExpandedItems(prev => 
      prev.includes(itemId) 
        ? prev.filter(id => id !== itemId)
        : [...prev, itemId]
    );
  };

  const hasAccess = (roles?: string[]): boolean => {
    if (!roles || roles.length === 0) return true;
    return user?.role ? roles.includes(user.role) : false;
  };

  const isActiveRoute = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  const renderMenuItem = (item: NavigationItem, level = 0): React.ReactNode => {
    if (!hasAccess(item.roles)) return null;

    const isExpanded = expandedItems.includes(item.id);
    const hasChildren = item.children && item.children.length > 0;
    const isActive = item.path ? isActiveRoute(item.path) : false;
    const shouldExpand = !isCollapsed || isMobile;

    const handleClick = () => {
      if (hasChildren) {
        if (shouldExpand) {
          handleToggleExpanded(item.id);
        }
      } else if (item.path) {
        handleNavigate(item.path);
      }
    };

    return (
      <React.Fragment key={item.id}>
        <ListItem disablePadding sx={{ display: 'block' }}>
          <Tooltip
            title={isCollapsed && !isMobile ? item.label : ''}
            placement="right"
            arrow
          >
            <ListItemButton
              onClick={handleClick}
              sx={{
                minHeight: 48,
                justifyContent: shouldExpand ? 'initial' : 'center',
                px: 2.5,
                pl: level > 0 ? 7 : 2.5,
                borderRadius: '0 24px 24px 0',
                mx: 1,
                transition: 'all 0.2s ease',
                bgcolor: isActive 
                  ? 'primary.main'
                  : 'transparent',
                color: isActive ? '#ffffff' : 'text.primary',
                '&:hover': {
                  bgcolor: isActive 
                    ? 'primary.dark' 
                    : theme.palette.action.hover,
                  color: isActive ? '#ffffff' : 'primary.main',
                },
                '& .MuiListItemIcon-root': {
                  color: isActive ? '#ffffff' : 'inherit',
                },
                '& .MuiListItemText-primary': {
                  fontWeight: isActive ? 600 : 400,
                  color: isActive ? '#ffffff' : 'inherit',
                },
              }}
            >
              {level === 0 && (
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    ml: shouldExpand?'auto': -.5,
                    mr: shouldExpand ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  {item.icon}
                </ListItemIcon>
              )}
              {shouldExpand && (
                <>
                  <ListItemText 
                    primary={item.label}
                    sx={{
                      '& .MuiListItemText-primary': {
                        fontSize: '0.875rem',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      },
                    }}
                  />
                  {hasChildren && (
                    isExpanded ? <ExpandLessRounded /> : <ExpandMoreRounded />
                  )}
                </>
              )}
            </ListItemButton>
          </Tooltip>
        </ListItem>
        {hasChildren && shouldExpand && (
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {item.children!.map(child => renderMenuItem(child, level + 1))}
            </List>
          </Collapse>
        )}
      </React.Fragment>
    );
  };

  const drawerContent = (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        overflowX: 'hidden',
      }}
    >
      {/* Logo/Brand Section */}
      {/* <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: isCollapsed ? 'center' : 'flex-start',
          px: isCollapsed ? 1 : 2,
          py: 2,
          minHeight: 64,
        }}
      >
        <School
          sx={{
            color: 'primary.main',
            fontSize: 32,
            mr: isCollapsed ? 0 : 1,
          }}
        />
        {!isCollapsed && (
          <Box sx={{ ml: 1 }}>
            <Box
              component="span"
              sx={{
                fontWeight: 'bold',
                fontSize: '1.1rem',
                color: 'text.primary',
                display: 'block',
                lineHeight: 1.2,
              }}
            >
              School
            </Box>
            <Box
              component="span"
              sx={{
                fontSize: '0.8rem',
                color: 'text.secondary',
                display: 'block',
                lineHeight: 1,
              }}
            >
              Admin Panel
            </Box>
          </Box>
        )}
      </Box>

      <Divider /> */}

      {/* Navigation Items */}
      <List sx={{ flexGrow: 1, px: 0, py: 1 , mt:2}}>
        {navigationItems.map((item) => renderMenuItem(item))}
      </List>
    </Box>
  );

  if (isMobile) {
    return (
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onMobileClose}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 2, // Higher than AppBar
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: DRAWER_WIDTH,
            border: 'none',
            bgcolor: 'background.paper',
          },
        }}
      >
        {drawerContent}
      </Drawer>
    );
  }

  return (
    <>
      {/* Blur Backdrop for Desktop Sidebar Expansion */}
      {isHovered && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backdropFilter: 'blur(8px)',
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            zIndex: theme.zIndex.drawer - 1,
            pointerEvents: 'none',
            transition: 'opacity 0.2s ease-out',
          }}
        />
      )}

      {/* Desktop Sidebar */}
      <Box
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        sx={{
          position: 'fixed',
          left: 10,
          top: '80px', // AppBar height + margin
          bottom: 8,
          width: drawerWidth,
          zIndex: theme.zIndex.drawer,
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.easeOut,
            duration: 200,
          }),
          willChange: 'width',
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '99%',
            bgcolor: 'background.paper',
            borderRadius: 2,
            border: `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.08)'}`,
            overflow: 'hidden',
            boxShadow: isHovered 
              ? '0 8px 32px rgba(0, 0, 0, 0.15)'
              : 'none',
            transition: theme.transitions.create('box-shadow', {
              easing: theme.transitions.easing.easeOut,
              duration: 200,
            }),
            contain: 'layout style paint',
          }}
        >
          {drawerContent}
        </Box>
      </Box>
    </>
  );
};